<section class="container">
  <div class="header-wrapper d-flex justify-content-between align-items-center">
    <div class="page_header">
        <button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h2 translate class="page-main-title m-0">Accordion Details</h2>
    </div>
    <button
      mat-raised-button
      color="primary"
      class="add-accordion-btn"
      (click)="openDynamicPageCreationDialog()"
    >
      <i class="fa-solid fa-plus add_button"></i
      ><span translate>Add Accordion Details</span>
    </button>
  </div>
  <app-expansion-panel
    *ngIf="accordionItems.length > 0"
    [items]="accordionItems"
    (itemExpanded)="onItemExpanded($event)"
    (itemCollapsed)="onItemCollapsed($event)"
    [selectedId]="selectedId"
    (actionClicked)="onActionClicked($event)"
  ></app-expansion-panel>
</section>
